import { createSelector } from 'reselect';

const sideNavSelector = state => state.sidenav;

export const selectDesktopNavIsCollapsed = createSelector(sideNavSelector, sidenav => sidenav.desktopIsCollapsed);
